import { render, staticRenderFns } from "./NtmSelect.vue?vue&type=template&id=1f6d453d"
import script from "./NtmSelect.vue?vue&type=script&lang=js"
export * from "./NtmSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports